import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import { Observable } from 'rxjs';
import {RoleUtils} from "../../utils/role/role-utils";
import { SessionProviderService } from 'src/app/services/sp-authentication/session-provider.service';

@Injectable({
  providedIn: 'root'
})
export class AccountGuard implements CanActivate {
  constructor(private router: Router, protected sessionProvider: SessionProviderService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Promise<boolean | UrlTree>(async resolve => {
      const data = next.data;
      const freemiumAccess = data.freemiumAccess || false;
      const trialAccess = data.trialAccess || false;
      if(this.sessionProvider.activeSession) {
        const hasAccounts = this.sessionProvider.activeSession.user.ad_accounts.length > 0;
        const trial = this.sessionProvider.activeSession.user.role.level === RoleUtils.trialLevel;
        const freemium = this.sessionProvider.activeSession.user.role.level <= RoleUtils.freemiumLevel;
        const bypass = await this.sessionProvider.activeSession.hasPermission('adaccount.bypass');
        hasAccounts || (freemiumAccess && freemium) || (trial && trialAccess) || bypass ? resolve(true) : resolve(this.router.navigate(['/account/edit']));//resolve(this.router.parseUrl('/page-access-denied'));
      } else {
        const sub = this.sessionProvider.sessionChangeListener.subscribe(async session => {
          if (session) {
            const hasAccounts = session.user.ad_accounts.length > 0;
            const trial = session.user.role.level === RoleUtils.trialLevel;
            const freemium = session.user.role.level <= RoleUtils.freemiumLevel;
            const bypass = await this.sessionProvider.activeSession.hasPermission('adaccount.bypass');
            hasAccounts || (freemiumAccess && freemium) || (trial && trialAccess) || bypass ? resolve(true) : resolve(this.router.navigate(['/account/edit']));//resolve(this.router.parseUrl('/page-access-denied'));
            sub.unsubscribe();
          }
        });
      }
    });
  }

}
